// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoDisclaimer_wrapper__iPLNa","content":"VideoDisclaimer_content__N1I6v","progressBar":"VideoDisclaimer_progressBar__EVKRh","progress":"VideoDisclaimer_progress__udmU3"};